import { useEffect, useState } from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';

export const MODE_BUTTON_ACTIVE_COLOR = '#4f74b7';
export const MODE_BUTTON_INACTIVE_COLOR = '#2b3d53';

const createModeButtonStyle = (color) => ({
  backgroundColor: color,
  borderColor: color,
  color: '#ffffff',
  '--bs-btn-bg': color,
  '--bs-btn-border-color': color,
  '--bs-btn-hover-bg': color,
  '--bs-btn-hover-border-color': color,
  '--bs-btn-active-bg': color,
  '--bs-btn-active-border-color': color,
  '--bs-btn-hover-color': '#ffffff',
  '--bs-btn-active-color': '#ffffff',
  '--bs-btn-focus-shadow-rgb': '0 0 0',
});

const DEFAULT_ACTIVE_STYLE = createModeButtonStyle(MODE_BUTTON_ACTIVE_COLOR);
const DEFAULT_INACTIVE_STYLE = createModeButtonStyle(MODE_BUTTON_INACTIVE_COLOR);

const ModeButton = ({
  options = [],
  onChange = () => {},
  selectedOption = null,
  enabled = true,
  evenButtons = true,

  activeStyle = DEFAULT_ACTIVE_STYLE,
  inactiveStyle = DEFAULT_INACTIVE_STYLE,
  buttonClassName = '',
  wrapperClassName = '',

  // NEW (all optional, with defaults matching current behavior)
  className = '',
  groupStyle = {},
  size = 'md',
  pill = false,
}) => {
  const [selected, setSelected] = useState(selectedOption ?? options[0]);

  useEffect(() => {
    if (selectedOption !== null && selectedOption !== undefined) {
      setSelected(selectedOption);
    }
  }, [selectedOption]);

  const updateSelection = (value) => {
    setSelected(value);
    onChange(value);
  };

  return (
    <ButtonGroup
      className={`w-100 shadow-sm mode-button-group ${wrapperClassName}`}
      style={{ borderRadius: 12, overflow: 'hidden' }}
    >
      {Array.isArray(options) &&
        options?.map((option, index) => {
          const isActive = selected === option;
          return (
            <Button
              key={`ModeButton#${index}`}
              className={`p-2 flex-fill fs-6 border-0 mode-button${
                index > 0 ? ' mode-button-sep' : ''
              } ${
                evenButtons ? 'flex-basis-0 min-w-0' : ''
              } ${buttonClassName} ${isActive ? 'mode-btn-active' : 'mode-btn-inactive'}`}
              variant={isActive ? 'primary' : 'outline-primary'}
              style={isActive ? activeStyle : inactiveStyle}
              onClick={() => updateSelection(option)}
              disabled={!enabled}
            >
              {option}
            </Button>
          );
        })}
    </ButtonGroup>
  );
};

export default ModeButton;
